import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { TiVoPublications } from "./types";

export const useVariantPublications = (
  id?: string,
  variantId?: string,
  queryParams?: ApiQueryParams
) => {
  const dispatch = useDispatch();
  return useQuery<ApiResponse<TiVoPublications>>({
    queryKey: ["variantPublications", id, variantId, queryParams],
    queryFn: async ({ signal }) => {
      return dispatch(
        apiThatThrows.getTiVoVariantPublications.action({
          params: { id, variantId },
          queryParams,
          abortSignal: signal,
        })
      );
    },
    enabled: Boolean(id && variantId),
  });
};
